import Immutable from 'immutable';

const LOAD = 'providerExpenses/LOAD';
const LOAD_SUCCESS = 'providerExpenses/LOAD_SUCCESS';
const LOAD_FAIL = 'providerExpenses/LOAD_FAIL';
const SUBMIT_SUCCESS = 'providerExpenses/SUBMIT_SUCCESS';

const initialState = Immutable.fromJS({
    isLoad: false,
    loadErr: null,
    expenses: [],
    count: 0
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD:
            return state.set('isLoad', true).set('loadErr', null);

        case LOAD_SUCCESS: {
            const res = action.res || {};
            const rows = Array.isArray(res.rows) ? res.rows : (Array.isArray(res) ? res : []);
            const count = typeof res.count === 'number' ? res.count : rows.length;
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('expenses', rows)
                .set('count', count);
        }

        case SUBMIT_SUCCESS:
        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', null);

        default:
            return state;
    }
}

export const submitExpense = (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
        if (data.receipts) {
            data.receipts = JSON.stringify(data.receipts);
        }
        const res = await api.post('/expense-reports/submit', { data });
        dispatch({ type: SUBMIT_SUCCESS });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
        return false;
    }
};

export const getExpenses = (params = {}) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
        const query = [];
        if (params.page) query.push(`page=${encodeURIComponent(params.page)}`);
        if (params.pageSize) query.push(`pageSize=${encodeURIComponent(params.pageSize)}`);
        if (params.status) query.push(`status=${encodeURIComponent(params.status)}`);
        if (Array.isArray(params.roles) && params.roles.length) {
            query.push(`roles=${encodeURIComponent(params.roles.join(','))}`);
        }
        const qs = query.length ? `?${query.join('&')}` : '';
        const res = await api.get(`/expense-reports${qs}`);
        dispatch({ type: LOAD_SUCCESS, res });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
    }
};

export const reviewExpense = (data) => async (dispatch, getState, api) => {
    try {
        const res = await api.put('/expense-reports/review', { data });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
        return false;
    }
};

export const updateExpense = (data) => async (dispatch, getState, api) => {
    try {
        const { id, ...body } = data;
        const res = await api.put(`/expense-reports/${id}`, { data: body });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
        return false;
    }
};

export const deleteExpense = (id) => async (dispatch, getState, api) => {
    try {
        const res = await api.del(`/expense-reports/${id}`);
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
        return false;
    }
};
